import { isZyapp } from "@/utils/modulesForApp";
/**
 * 从url上获取参数
 * @param 需要获取的参数
 * 
 */
const getUrlParams = param => {
	const reg = new RegExp(`(^|&)${param}=([^&]*)(&|$)`, "i");
	const url = location.href;
	const r = url.substr(url.indexOf("?") + 1).match(reg);
	if (r) {
		return decodeURI(r[2]);
	}
	return "";
};

const compareV = reqV => {
	if (!isZyapp()) {
		return;
	}
	const curV = window.navigator.userAgent
		.toLowerCase()
		.match(/zyapp(\S*)/)[1]
		.substring(1)
		.trim();
	if (curV && reqV) {
		//将两个版本号拆成数字
		let arr1 = curV.split("."),
			arr2 = reqV.split(".");
		let minLength = Math.min(arr1.length, arr2.length),
			position = 0,
			diff = 0;
		// 依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
		while (position < minLength && (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0) {
			position++;
		}
		diff = diff != 0 ? diff : arr1.length - arr2.length;
		//若curV大于reqV，则返回true
		return diff >= 0;
	} else {
		//输入为空
		console.log("版本号不能为空");
		return false;
	}
};

// 获取用户标签方法
const getUserInfoLabel = (userInfo) => {
    const accountId = userInfo?.trade_account_list?.length ? userInfo?.trade_account_list[0]?.accountid : '';
    const labels = userInfo?.label_ids;
    let labelIds = {
        'cmbi-label': '',
        'cmbi-account-label': ''
    };
    if (labels?.length > 0) {
        labels.forEach(item => {
            if (item?.account_id == '') {
                labelIds['cmbi-label'] = item?.app_label_ids;
            }
            if (accountId) {
                if (item?.account_id == accountId) {
                    labelIds['cmbi-account-label'] = item?.app_label_ids;
                }
            }
        });
    }
    return labelIds;
}

export {getUrlParams, compareV, getUserInfoLabel};